// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"123":"case","357":"casesFrame","794":"cases","933":"auth"}[chunkId] || chunkId) + "." + {"123":"ebb13407","163":"acaa0fe2","288":"3b960e8a","357":"f7f86cac","794":"70047a37","865":"b3e76979","933":"3b503441","986":"1ca9536b"}[chunkId] + ".css";
};